export default class CepFormatter {
  public static removeMask(value: string): string {
    return value.replace(/\D/g, ''); // Remove todos os caracteres não numéricos
  }
  
  public static formatarCep(cep: string): string {
    const apenasNumeros = this.removeMask(cep);
  
    // Verifica se o CEP possui 8 dígitos
    if (apenasNumeros.length === 8) {
      return `${apenasNumeros.slice(0, 5)}-${apenasNumeros.slice(5)}`;
    } else {
      throw new Error('CEP inválido. Deve conter 8 dígitos.');
    }
  }
}
  
